import styled, { css } from 'styled-components';
import { PanelContainer } from '../../../panel';
import { pxToRem } from '../../../../design-tokens/style-utilities';
/**
 * Login In Context Container
 */
export const loginInContextContainerStyles = ({ theme }) => css `
	display: flex;

	${PanelContainer} {
		flex: 0 0 50%;
		min-height: 100%;
		border: 0;
		border-radius: 0;
	}

	p {
		margin-bottom: ${pxToRem(theme.spacing['200'])};
	}
`;
export const LoginInContextContainer = styled.div `
	${loginInContextContainerStyles}
`;
